import BackNextNav from '@/components/common/BackNextNav';
import { BigHeader, Paragraph } from '@/components/common/Typography';
import SharingAccountsSection from '@/components/settings/SharingAccountsSection';
import { FlexProps } from '@chakra-ui/react';
import React from 'react';

interface AcceptInviteSharingViewProps extends FlexProps {
    onNext: () => void;
}

export default function AcceptInviteSharingView({
    onNext,
}: AcceptInviteSharingViewProps) {
    return (
        <>
            <BigHeader mb={5}>Your privacy & sharing</BigHeader>
            <Paragraph color="textMuted" mb={15} maxW={500}>
                Work together to plan, invest, and track your finances so you
                stay on the same page and everything stays organized. Plus,
                enjoy the flexibility to share some things and keep others
                private.
            </Paragraph>

            <SharingAccountsSection />

            <BackNextNav
                onNext={onNext}
                onClickEventParams={{
                    location: 'Accept Invite Sharing View',
                }}
            />
        </>
    );
}
